const userAgentInfo = {
  isMobile: false,
  isWechat: false,
  isMqq: false,
  isAndroid: false,
  isIOS: false,
  isIPad: false,
  isSafari: false
}
let ua = navigator.userAgent

let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
for (let v = 0; v < Agents.length; v++) {
  if (ua.indexOf(Agents[v]) > 0) {
    userAgentInfo.isMobile = true
    break
  }
}
if (/ipad/.test(ua.toLowerCase())) {
  userAgentInfo.isIPad = true
}
if (/iphone|ipad|ipod/.test(ua.toLowerCase())) {
  userAgentInfo.isIOS = true
}
if (/android|linux/.test(ua.toLowerCase())) {
  userAgentInfo.isAndroid = true
}
if (ua.toLowerCase().indexOf('micromessenger') !== -1) {
  userAgentInfo.isWechat = true
}
if (ua.toLowerCase().indexOf(' qq/') !== -1) {
  userAgentInfo.isMqq = true
}
if (ua.toLowerCase().indexOf('quark') !== -1) {
  userAgentInfo.isQuark = true
}
if (/Safari/.test(ua) && !/Chrome/.test(ua)) {
  userAgentInfo.isSafari = true
}

export default userAgentInfo
